module.exports = __webpack_public_path__ + "static/media/background-desktop-login.af8098a1.svg";